import styles from "./referralDomainScreenBackground.module.scss";

/** Домен referral: вертикальный градиент #201D31 → #3C3962 */
export function ReferralDomainScreenBackground() {
  return <div className={styles.root} aria-hidden />;
}
